'use strict';

function dateStringToDate(date) {
  var split = date.split('/');
  var year = +split[2]; //make integer
  if(year < 100){
    year += 2000;
  }
  var month = +split[1] - 1; //make integer and zero indexed
  var day = +split[0]; //make integer
  return new Date(year, month, day);
}

export default class TutorsController {
  /*@ngInject*/
  constructor($http, CreateTutorFactory, EditTutorFactory) {
    this.$http = $http;
    this.tutors = [];
    this.CreateTutorFactory = CreateTutorFactory;
    this.EditTutorFactory = EditTutorFactory;
    this.showErrors = false;
  }

  $onInit(){
  	this.loadTutors();
  }

  loadTutors(){

  	this.$http.get('/api/tutors').then(res => {
  		this.tutors = res.data || [];
  		this.tutors = this.tutors.map(tutor => {
  			tutor.fullName = tutor.nameFirst + ' ' + tutor.nameLast;

  			return tutor;
  		});
  	})
  }

  findInactives(){
    this.finding = true;
    this.$http.post('/api/tutors/find-inactives').then(res => {
      this.finding = false;
      this.tutors = [];
      this.loadTutors();
    })
  }

  toggleActivate(tutor){

  	tutor.isActive = !tutor.isActive;

  	this.$http.put('/api/tutors/' + tutor._id, tutor).then(res => {
  		console.log('tutor toggled');
  	})
  }

  checkShow(tutor){
  	if(this.showErrors === false){
  		return false;
  	}

    if(!tutor.isActive){
      return true;
    }

  	function compareDates(expiresDate){
  		//accepts wwcExpires date string
  		//returns true if all ok
  		//returns false if date is surpassed or two months away
  		if(!expiresDate){
  			return false;
  		}
  		
  		var currentDate = new Date();
  		currentDate.setMonth(currentDate.getMonth() + 2);

  		var newDate = dateStringToDate(expiresDate);

  		return newDate.getTime() > currentDate.getTime();
  	}

  	const dateAllGood = compareDates(tutor.wwcExpires);
  	return !!(dateAllGood && tutor.wwcID && tutor.wwcState)
  }

  addTutor(){
    this.CreateTutorFactory().then(res => this.loadTutors());
  }

  editTutor(tutorID){
  	//note that this accepts the ._id versio of ID, not tutorID

  	this.EditTutorFactory(tutorID).then(res => this.loadTutors());
  }
}



// WEBPACK FOOTER //
// ./client/app/tutors/tutors.controller.js